import { memo, useCallback } from "react"
import styled from "styled-components"
import { EditProfile } from "./UserEdit"
import BodyText from "components/Typography/BodyText"
import IconEdit from "components/EvtKit/icons/IconEdit"
import Heading from "components/Typography/Heading"

const ContainerNameEdit = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-end;
`
const InfoGroup = styled.div`
  display: grid;
  gap: 4px;
`
const ContainerIcon = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;

  max-height: 48px;
  max-width: 248px;

  & p {
    display: flex;
    max-width: 224px;
    max-height: 48px;
    overflow: auto;
    white-space: nowrap;

    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

    &::-webkit-scrollbar-track {
      background: ${(props) => props.theme.palette.gray_ice};
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background: ${(props) => props.theme.palette.gray_light};
      border-radius: 10px;
      cursor: pointer;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: ${(props) => props.theme.palette.gray_medium};
    }
  }
`

const ButtonEdit = styled.button`
  & svg {
    width: 16px;
    height: 16px;
  }
`

interface Props {
  setEditing: React.Dispatch<React.SetStateAction<boolean>>
  editedValue: EditProfile
}

const UserBeforeEdit = (props: Props) => {
  const { setEditing, editedValue } = props
  const handleEditClick = useCallback(() => {
    setEditing(true)
  }, [setEditing])

  return (
    <ContainerNameEdit>
      <InfoGroup>
        <Heading variant="h6">Nome Completo</Heading>
        <ContainerIcon>
          <BodyText size="semi-medium">{editedValue.name}</BodyText>
          <ButtonEdit type="button" onClick={handleEditClick}>
            <IconEdit />
          </ButtonEdit>
        </ContainerIcon>
      </InfoGroup>
    </ContainerNameEdit>
  )
}

export default memo(UserBeforeEdit)
